<template>
  <div>
    <!-- <button
            :loading="loading"
            v-bind:class="verifyLocked()"
            v-bind:style="{
                backgroundColor: course.button_color + ' !important',
                color: course.button_text_color + ' !important'
            }"
            @click="goToMatricula()"
            v-if="course.status_mode === statusModeButton">
            {{ course.button_text }}
        </button> -->

    <v-btn
      :loading="loading"
      class="btn-basic uppercase"
      :class="verifyLocked()"
      :style="{
        backgroundColor: course.button_color + ' !important',
        color: course.button_text_color + ' !important'
      }"
      @click="goToMatricula()"
      v-if="course.status_mode === statusModeButton"
    >
      {{ course.button_text }}
    </v-btn>

    <div
      :class="
        typeStructure == 'desktop'
          ? 'left_content_passed'
          : 'left_content_passed2'
      "
      v-if="course.status_mode === statusModeText"
    >
      <v-icon
        v-bind:style="{
          color: course.text_icon_color
        }"
        large
        >{{ course.text_icon }}</v-icon
      >

      <div class="passed_text">
        <strong
          v-bind:style="{
            color: course.text_color
          }"
        >
          {{ course.text_message }}
        </strong>
      </div>
    </div>
  </div>
</template>
<script>
import { mapState, mapMutations } from "vuex";
import jwt from "jwt-simple";
import axios from "../axios-auth";

export default {
  name: "CheckEnrollment",
  data() {
    return {
      user: null,
      postulation: null,
      language: null,
      program: null,
      loading: false
    };
  },
  props: ["course", "typeStructure"],
  computed: {
    ...mapState([
      "statusCourse",
      "statusModeButton",
      "statusModeText",
      "secretKeyJwt"
    ])
  },
  methods: {
    ...mapMutations(["setLanguage", "setProgram", "setPostulation"]),
    mounted() {
      this.setLanguage(null);
      this.setProgram(null);
      this.setPostulation(null);
    },
    verifyLocked() {
      if (!this.course.button_enabled || this.user.has_debt) {
        return this.typeStructure == "desktop"
          ? "btn--primary reduced locked_button"
          : "btn--primary btn_matriculate2 locked_button";
      } else
        return this.typeStructure == "desktop"
          ? "btn--primary reduced"
          : "btn--primary btn_matriculate2";
    },
    goToMatricula() {
      if (!this.user.has_debt) {
        this.loading = true;
        switch (this.course.status) {
          case this.statusCourse.statusCase3:
            this.registerPostulation();
            this.loading = false;
            break;

          case this.statusCourse.statusCase2:
          case this.statusCourse.statusCase4:
            this.goRegister();
            break;

          case this.statusCourse.statusCase14:
            this.loadPostulation(this.course.last_postulation);
            break;

          default:
            if (this.course.button_enabled) {
              this.goRegister();
            }
        }
        this.loading = false;
      } else {
        return;
      }

      // if(this.course.status === this.statusCourse.statusCase3) {
      //     this.loading = true;
      //     this.registerPostulation();
      //
      // } else if ((this.course.status === this.statusCourse.statusCase2 ||
      //     this.course.status === this.statusCourse.statusCase4 ||
      //     this.course.button_enabled) && !this.user.has_debt) {
      //
      //         if (localStorage.lastCourse) {
      //             localStorage.removeItem("lastCourse");
      //         }
      //         var secret = this.secretKeyJwt;
      //         var course = jwt.encode(this.course, secret);
      //         localStorage.setItem("lastCourse", course);
      //
      //         if(this.course.status === this.statusCourse.statusCase6){
      //             this.$emit('showPendingPay');
      //         } else {
      //             this.$router.push("/enrollment/" + this.course.course_id);
      //         }
      // } else {
      //     return;
      // }
    },
    goRegister() {
      if (localStorage.lastCourse) {
        localStorage.removeItem("lastCourse");
      }
      var secret = this.secretKeyJwt;
      var course = jwt.encode(this.course, secret);
      localStorage.setItem("lastCourse", course);

      if (this.course.status === this.statusCourse.statusCase6) {
        this.$emit("showPendingPay");
      } else {
        this.$router.push("/enrollment/" + this.course.course_id);
      }
    },
    registerPostulation() {
      let obj = {
        application_id: "0",
        program: this.course.curriculum_id,
        up_user: this.user.username
      };
      axios
        .post(`users/register-postulation/`, obj, {
          headers: { Authorization: "Token " + this.user.token }
        })
        .then(response => {
          this.loadPostulation(response.data.application_id);
        })
        .catch(err => {
          console.error(err);
          this.loading = false;
        });
    },
    loadPostulation(id) {
      let obj = {
        user_id: this.user.username,
        postulation_id: id
      };
      axios
        .post(`users/list-postulation/`, obj, {
          headers: { Authorization: "Token " + this.user.token }
        })
        .then(response => {
          let postulationList = response.data.detail;
          this.postulation = postulationList.find(
            s => s.program_id === this.course.curriculum_id
          );
          this.loadLanguages();
        })
        .catch(err => {
          console.error(err);
        });
    },
    loadLanguages() {
      axios
        .get(`languages/list/`, {
          headers: { Authorization: "Token " + this.user.token }
        })
        .then(response => {
          return response.data;
        })
        .then(res => {
          if (res) {
            this.language = res.find(l => l.id === this.course.language_id);
            this.program = this.language.program_list.find(
              p => p.id === this.course.curriculum_id
            );
            this.setRecords();
          }
        });
    },
    setRecords() {
      this.setLanguage(this.language);
      this.setProgram(this.program);
      this.setPostulation(this.postulation);

      if (this.program.require_survey && this.postulation.has_survey) {
        //no ha resuelto la encuesta
        this.$router.push({ path: `/poll` });
      } else {
        //postulación pendiente: antes de iniciar el examen
        this.goTo(this.postulation.status.id);
      }

      // if(this.program.require_survey && this.postulation.has_survey) {
      //     this.$router.push({ path: `/poll` });
      // } else if(this.program.require_evaluation) {
      //     this.$router.push({ path: `/exam` });
      // } else if(this.program.require_interview) {
      //     this.$router.push({ path: `/evaluation/schedule` });
      // } else {
      //     this.language = null;
      //     this.program = null;
      //     this.isShow = false;
      //     // this.loadPostulation(0);
      //     this.$emit('status','enrollment');
      // }
    },
    goTo(statusId) {
      switch (statusId) {
        case 1: //postulación pendiente
          this.$router.push({ path: `/exam` });
          break;
        case 2: //debe resolver encuesta
          this.$router.push({ path: `/poll` });
          break;
        case 3: //evaluación en proceso
          this.$router.push({ path: `/evaluation` });
          break;
        case 4: //evaluación en finalizada
          this.$router.push({ path: `/evaluation/schedule` });
          break;
        case 5: //asesoria programada
          this.$router.push({ path: `/evaluation/schedule` });
          break;
        case 6: //asesoria terminada pero sin calificación
          this.$router.push({ path: `/evaluation/schedule/rate` });
          break;
        case 7: //proceso terminado
          this.$emit("status", "enrollment");
          this.$vuetify.goTo("#top", {
            duration: 0,
            offset: 0,
            easing: "linear"
          });
          break;
      }
    }
  },
  created() {
    this.user = this.$store.state.usuario;
  }
};
</script>
<style media="screen">
.right_detailt_up .v-btn__content {
  flex: auto;
  white-space: normal;
}
</style>
